import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import type {
    CareerPath,
    CareerPathExtendPayload,
    CareerPathNote,
    CareerPathNotePayload,
    CareerPathPayload,
    CareerPathTransitionPayload,
} from '../types/career-path'

export const getCareerPaths = async (
    employeeId: number
): Promise<ResponseArray<CareerPath>> => {
    const response = await datacentral.get(
        `/employees/${employeeId}/career-paths`
    )
    return response.data
}

export const createCareerPath = async (payload: {
    employeeId: number
    data: CareerPathPayload
}): Promise<ResponseObject<CareerPath>> => {
    const response = await datacentral.post(
        `/employees/${payload.employeeId}/career-paths`,
        payload.data
    )
    return response.data
}

export const updateCareerPath = async (payload: {
    employeeId: number
    careerPathId: number
    data: Partial<CareerPathPayload>
}): Promise<ResponseObject<CareerPath>> => {
    const response = await datacentral.put(
        `/employees/${payload.employeeId}/career-paths/${payload.careerPathId}`,
        payload.data
    )
    return response.data
}

export const deleteCareerPath = async (payload: {
    employeeId: number
    careerPathId: number
}) => {
    const response = await datacentral.delete(
        `/employees/${payload.employeeId}/career-paths/${payload.careerPathId}`
    )
    return response.data
}

export const createCareerPathNote = async (payload: {
    employeeId: number
    careerPathId: number
    data: CareerPathNotePayload
}): Promise<ResponseObject<CareerPathNote>> => {
    const response = await datacentral.post(
        `/employees/${payload.employeeId}/career-paths/${payload.careerPathId}/notes`,
        payload.data
    )
    return response.data
}

export const extendCareerPath = async (payload: {
    employeeId: number
    careerPathId: number
    data: CareerPathExtendPayload
}): Promise<ResponseObject<CareerPath>> => {
    const response = await datacentral.post(
        `/employees/${payload.employeeId}/career-paths/${payload.careerPathId}/extend`,
        payload.data
    )
    return response.data
}

export const transitionCareerPath = async (payload: {
    employeeId: number
    careerPathId: number
    data: CareerPathTransitionPayload
}) => {
    const response = await datacentral.post(
        `/employees/${payload.employeeId}/career-paths/${payload.careerPathId}/transition`,
        payload.data
    )
    return response.data
}

export const deleteCareerPathNote = async (payload: {
    employeeId: number
    careerPathId: number
    noteId: number
}) => {
    const response = await datacentral.delete(
        `/employees/${payload.employeeId}/career-paths/${payload.careerPathId}/notes/${payload.noteId}`
    )
    return response.data
}
